import TeamOverviewEmpDetail from './TeamOverviewEmpDetail';

export default TeamOverviewEmpDetail;
